"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var conversationService_1 = require("./../../../Services/conversationService");
var app_nav_component_1 = require("./../../../Nav/app-nav.component");
var service_service_1 = require("./../../../Services/service.service");
var delete_account_dialog_component_1 = require("../../../Dialogs/delete-account-dialog/delete-account-dialog.component");
var AccountComponent = /** @class */ (function (_super) {
    __extends(AccountComponent, _super);
    function AccountComponent(mainService, conversationService, dialog) {
        var _this = _super.call(this, mainService, conversationService, dialog) || this;
        _this.enableSubscription = false;
        _this.enableSubscription = mainService.enableSubscription;
        mainService.pageName = "My Account";
        return _this;
    }
    AccountComponent.prototype.showAllNonDemoAds = function () {
        this.mainService.route.navigate(["/non-demo-ads"]);
    };
    AccountComponent.prototype.showDeleteAccountModal = function () {
        var dialogRef = this.dialog.open(delete_account_dialog_component_1.DeleteAccountDialog, {
            autoFocus: true,
            hasBackdrop: true,
            disableClose: true,
            data: {},
        });
    };
    return AccountComponent;
}(app_nav_component_1.AppNavComponent));
exports.AccountComponent = AccountComponent;
